import { catchError, map} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
export class CommonService {
  constructor(private urlModule: any, public http: HttpClient) {
  }
  baseUrl = environment.baseURL + this.urlModule;


  getAll() {
    return this.http.post(this.baseUrl, {}).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        return null;
      })
    );
  }

  getOne(id) {
    return this.http.get(this.baseUrl+id).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        return null;
      })
    );
  }
  searchAll(searchObj) {
    return this.http.post(this.baseUrl, searchObj).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        return null;
      })
    );
  }

  create(resource): Observable<any> {
    return this.http.post(this.baseUrl+ '/create', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(err => {
          return null;
        })
      );
  }

  update(resource) {
    return this.http.put(this.baseUrl, resource).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        return null;
      })
    );
  }

  delete(id) {
    return this.http.delete(this.baseUrl + '/' + id).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        return null;
      })
    );
  }

  getCount() {
    return this.http.get(this.baseUrl + '/count').pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        return null;
      })
    );
  }

  deleteSelected(idsForDeletion) {
    return this.http.post(this.baseUrl + '/updateMany', idsForDeletion).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        return null;
      })
    );
  }

  updateStatusMany(obj) {
    return this.http.post(this.baseUrl + '/updateMany', obj).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        return null;
      })
    );
  }
  UpdatePublishUser(obj) { 
    return this.http.put(this.baseUrl +'/Update-PublishUser?Id='+obj.userId, obj).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        return null;
      })
    );
  }
  UpdateDisplayOrder(obj: any) {   
    return this.http.put(this.baseUrl +'/Update-DisplayOrder', obj).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(err => {
        return null;
      })
    );
  }
  deleteImage(obj) {
      return this.http.post(this.baseUrl + '/removeImage', obj).pipe(
        map((response: any) => {
          return response;
        }),
        catchError(err => {
          return null;
        })
      );
  }
}
